import { BILLING_CURRENCY } from "shared/PricingCalculator";
import type { Formats } from "use-intl/core";

export { APP_LOCALES as SUPPORTED_LOCALES, type AppLocale, DEFAULT_LOCALE } from "shared/Locale";
export const DEFAULT_TIME_ZONE = "UTC";

export const FORMATS = {
  dateTime: {
    date: {
      day: "numeric",
      month: "short",
      year: "numeric",
    },
    dateTime: {
      dateStyle: "medium",
      timeStyle: "short",
    },
    time: {
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
    },
  },
  number: {
    currency: {
      currency: BILLING_CURRENCY,
      style: "currency",
    },
    integer: {
      maximumFractionDigits: 0,
    },
    percent: {
      maximumFractionDigits: 1,
      style: "percent",
    },
  },
} satisfies Formats;
